import { gql } from '@apollo/client';

const GET_COMPANY_USER_LIABILITIES = gql`query getCompanyUserLiabilities($companyId: Int!) {
	companyAdminContext {
		subscriptions {
			getCompanyUserLiabilities(companyId: $companyId) {
				storageInfo{
					storageUsage
					storageDetails
					{
						siteId
						siteName
						usage
					}
				}
				ownUsers {
					company
					subscriptionLevel
					userId
					username
				}
				paymentLiableUsers {
					company
					subscriptionLevel
					userId
					username
					sitemembership{
						name
						siteId
						siteRole
						subscriptionLevel
					}
				}
			}
		}
	}
}
`;

export default GET_COMPANY_USER_LIABILITIES;